var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 12C3 9.51638 5.01638 7.5 7.5 7.5H40.5C42.9836 7.5 45 9.51638 45 12V36C45 38.4836 42.9836 40.5 40.5 40.5H7.5C5.01638 40.5 3 38.4836 3 36V12V12M6 32.12V36C6 36.828 6.672 37.5 7.5 37.5H40.5C41.3279 37.5 42 36.8279 42 36V32.12L36.62 26.742C35.4487 25.5722 33.5513 25.5722 32.38 26.742L30.62 28.5L32.56 30.44C32.9613 30.8139 33.1265 31.3771 32.9908 31.9086C32.855 32.44 32.44 32.855 31.9086 32.9908C31.3771 33.1265 30.8139 32.9613 30.44 32.56L20.12 22.242C18.9487 21.0722 17.0513 21.0722 15.88 22.242L6 32.122V32.12M26.25 16.5C26.25 15.2582 27.2582 14.25 28.5 14.25C29.7418 14.25 30.75 15.2582 30.75 16.5C30.75 17.7418 29.7418 18.75 28.5 18.75C27.2582 18.75 26.25 17.7418 26.25 16.5V16.5",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image-placeholder.e67dc027d6ca1bf4e4b8a65fdd8edfa0.svg";
export { ForwardRef as ReactComponent };